<template>
  <el-dialog top="5vh" :title="title" class="MeterEditor" :visible.sync="dialogVisible" :close-on-click-modal="false" :append-to-body="true" width="90vw" @close="closeWin">
    <MeterApportionTemplateCustomer v-if="dialogVisible" />
  </el-dialog>
</template>

<script>
import MeterApportionTemplateCustomer from "./MeterApportionTemplateCustomer";

export default {
  name: "ApportionTemplateWin",
  inject:['mainObj','componentId','setComponentId'],
  provide(){
    return{
      formData:()=>this.form_data
    }
  },
  components: {MeterApportionTemplateCustomer},
  data(){
    return{
      dialogVisible: false,
      form_data:{},
      title:"",
    }
  },
  methods:{
    show(item=null){
      if(!item) return false;
      this.form_data={id:item.id,name:item.name};
      this.title="设置分摊对象及分摊模式 - ";
      if(item.name){
        this.title+=` 【${item.name}】`
      }
      this.mainObj.id=item.id;
      this.dialogVisible=true;
    },
    closeWin(){
      this.mainObj.id="";
      this.form_data={};
    }
  }
}
</script>

<style lang="scss" scoped>
.MeterEditor{
  >>>.el-dialog__header{
    //padding: 10px 20px 5px;
  }
  >>>.el-dialog__body{
    padding-top: 5px;
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/apportion_template/components/ApportionTemplateWin.vue